// Font Awesome icons for public pages (login, support, newsletters).
// See shared/icons.js for the full app icon registry.

import "@fortawesome/fontawesome-svg-core/styles.css";
import { config, library, dom } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;

import {
  faCheck,
  faEye,
  faEyeSlash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";

import { faCopy as farCopy } from "@fortawesome/free-regular-svg-icons";

library.add(faCheck, faEye, faEyeSlash, faUpload, farCopy);

dom.watch();
